<template>
  <div class="r-card">
      <svg class="not-desktop frame" width="202px" height="284px" viewBox="0 0 202 284" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Layout-v9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="05-choose-radiance" transform="translate(-89.000000, -179.000000)" stroke="#CEBC9E" stroke-width="0.5">
                  <g id="Group-3" transform="translate(-124.000000, 180.000000)">
                      <g id="Group-5" transform="translate(214.000000, 0.000000)">
                          <polygon id="Stroke-2" points="4 278 196 278 196 4 4 4"></polygon>
                          <polygon id="Stroke-3" points="0 117.00309 0 267.13703 15.6987261 282.222222 181.821019 282.222222 200 269.456604 200 127.724986 200 76.7956609 200 12.1279107 181.821019 0 15.6987261 0 0 14.4481214 0 91.2030098"></polygon>
                      </g>
                  </g>
              </g>
          </g>
      </svg>

      <svg class="desktop-only frame-1440" width="364px" height="497px" viewBox="0 0 364 497" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Landing-1440-define-radiance" transform="translate(-540.000000, -295.000000)" stroke="#CEBC9E" stroke-width="0.5">
                  <g id="Group-5" transform="translate(541.000000, 296.000000)">
                      <polygon id="Stroke-2" points="7 487 355 487 355 6 7 6"></polygon>
                      <polygon id="Stroke-3" points="0 205.227642 0 468.567991 28.4583081 495.027962 329.601176 495.027962 362.555636 472.636607 362.555636 224.034235 362.555636 134.70236 362.555636 21.272793 329.601176 0 28.4583081 0 0 25.3425263 0 159.97337"></polygon>
                  </g>
              </g>
          </g>
      </svg>

      <!-- <div class="top-taller"></div> -->
      <div class="card-number" v-if="!frameOnly">
        {{ number }}
      </div>
      <div class="card-name" v-if="!frameOnly">{{ name }}</div>
  </div>
</template>

<script>
export default {
  props: {
    frameOnly: {
      default: false
    },
    opacity: {
      default: 1.0 // 0.3
    },
    name: {
      default: 'Kindness'
    },
    number: {
      default: 78
    },
    image: {}
  }
}
</script>

<style scoped>
.r-card{
  position: relative;
  /* width: 200px; */
  height: 285px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.frame{
  position: absolute;
  top: 0px;
  left: calc(50% - 200px / 2);
}
.frame-1440{
  position: absolute;
  top: 0px;
  left: calc(50% - 363px / 2);
}

.top-taller{
  height: 40px;
}

.card-number{
  /* 01: */
  /* border: 1px solid #FFFFFF; */
  font-family: PlayfairDisplay-Regular, CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0.5px;
  text-align: center;
  line-height: 20px;
  transform: translateY(-5px);
}

.card-name{
  white-space: pre;

  margin-top: 20px;
  text-transform: uppercase;
  /* Kindness: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 17px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 20px;
  transform: translateY(-5px);
}

/*
.card-photo{
  margin-top: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
*/

.desktop-only{
  display: none;
}
@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .not-desktop{
    display: none;
  }
  .desktop-only{
    display: block;
  }
  .frame-1440{
    position: absolute;
    top: 0px;
    left: calc(50% - 400px / 2);
    width: 400px;
    height: 580px;
  }
  .r-card{
    /* width: 363px; */
    height: 580px;
  }
  .card-number{
    font-size: 20px;
  }
  .card-name{
    font-size: 30px;
    letter-spacing: 3.3px;
    line-height: 40px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/DefineRadiance/RCard.vue